import { useContext } from "react";
import { ProjectEditingContext, type ProjectEditingContextValue } from "./projectEditingContext.ts";

/** Throws (rather than a "sensible default" like useLanguage()'s "es" fallback) — there's no meaningful default EvalHidProject, so a missing ProjectEditingProvider is always a real bug, not a legitimate standalone-render case. */
export function useProjectEditing(): ProjectEditingContextValue {
  const value = useContext(ProjectEditingContext);
  if (!value) throw new Error("useProjectEditing() called outside a ProjectEditingProvider");
  return value;
}
